/* global localStorage */
import { AnyAction, combineReducers, Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import { message } from 'antd';
import { globalReducer as global } from './global/globalReducer';
import { userReducer as user } from './user/userReducer';
import { deviceReducer as device } from './device/deviceReducer';
import { eventsReducer as events } from './events/eventsReducer';
import { assetReducer as asset } from './asset/assetReducer';
import { dashboardReducer as dashboard } from './dashboard/dashboardReducer';
import { driverReducer as driver } from './driver/driverReducer';
import { videoReducer as video } from './video/videoReducer';
import { comparisonReducer as comparison } from './comparison/comparisonReducer';
import { divisionReducer as division } from './division/divisionReducer';
import { departmentReducer as department } from './department/departmentReducer';
import { reportReducer as report } from './report/reportReducer';
import { smartWidgetReducer as smartWidget } from './smartWidget/smartWidgetReducer';
import { companyReducer as company } from './company/companyReducer';
import { shardLogReducer as shardLog } from './shardLog/shardLogReducer';
import { recordsReducer as records } from './records/recordsReducer';
import { filtersReducer as filters } from './filters/filtersReducer';
import { companyTagsReducer as companyTags } from './companyTag/companyTagsReducer';
import { geofenceReducer as geofence } from './geofence/geofenceReducer.ts';

const LOCAL_PERSIST_KEY = 'persist:root';

/**
 * Combine the various reducers. 
 * The rootReducer will call each and every reducer with the state and action EVERY time there is a basic action.
 */
const appReducers = combineReducers({
    global,
    user,
    device,
    events,
    asset,
    dashboard,
    driver,
    video,
    comparison,
    department,
    division,
    report,
    smartWidget,
    form: formReducer,
    company,
    shardLog,
    records,
    filters,
    companyTags,
    geofence,
});
export type RootState = ReturnType<typeof appReducers>;

function isUnauthorised(action: AnyAction): boolean {
    const statusCode: number = action?.payload?.response?.status || 404;
    const name: string = action?.payload?.response?.name || '';
    const responseMessage: string = action?.payload?.response?.message || '';
    const type: string = action?.payload?.response?.type || '';

    return (
        statusCode == 401 || 
        name.toLowerCase().includes('unauthorized') || 
        responseMessage.toLowerCase().includes('invalid credentials') ||
        type.toLowerCase().includes('unauthorizedhttpexception')
    );
}

function logout(): void {
    storage.removeItem(LOCAL_PERSIST_KEY);
    message.error('Your session has expired, logging you out...', 5);
    setTimeout(() => {
        window.location.href = '/';
    }, 1500);
}

const rootReducer: Reducer<RootState, AnyAction> = (
    state, 
    action
) => {
    if (
        typeof action.type === 'string' && 
        action.type.includes('_FAILURE') && 
        isUnauthorised(action)
    ) {
        logout();
        return appReducers(undefined, action);
    }
    return appReducers(state, action);
};

export default rootReducer;
